import React from "react";
import { useReveal } from "../../animations/hooks";

/**
 * Scroll-triggered reveal wrapper.
 *
 *   <Reveal>…</Reveal>                  fades + rises the whole block
 *   <Reveal stagger={0.1}>
 *     <div data-reveal>…</div>          each marked child animates in turn
 *   </Reveal>
 */
function Reveal({ as: Tag = "div", children, className, y, stagger, duration, delay, once, start, ...rest }) {
    const ref = useReveal({ y, stagger, duration, delay, once, start });
    return (
        <Tag ref={ref} className={className} {...rest}>
            {children}
        </Tag>
    );
}

export default Reveal;
